export const CHANGE_SEARCH_FIELD= 'CHANGE_SEARCH_FIELD';

// since it is a promise, it has 3 states
// standard for basic transactions like AJAX
export const REQUEST_ROBOTS_PENDING = 'REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_SUCCESS = 'REQUEST_ROBOTS_SUCCESS';
export const REQUEST_ROBOTS_FAILED = 'REQUEST_ROBOTS_FAILED';
export const CHANGE_ROBOTS = 'CHANGE_ROBOTS';